// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section {\n  align-items: center;\n  display: flex;\n  height: 39px;\n  min-width: 862px;\n  padding: 0 150px;\n}\n\n.vector-19 {\n  height: 1px;\n  margin-top: 1.0px;\n  width: 208px;\n}\n\n.trending-6 {\n  letter-spacing: 0;\n  line-height: 162px;\n  margin-left: 15px;\n  min-height: 39px;\n  min-width: 117px;\n  white-space: nowrap;\n}\n\n.vector-18 {\n  height: 1px;\n  margin-left: 15px;\n  margin-top: 1.0px;\n  width: 208px;\n}\n\n", ""]);
// Exports
module.exports = exports;
